import { createAsyncThunk } from "@reduxjs/toolkit";
import { createBanner, deleteBanner, fetchBanners, updateBanner } from "./bannersApi";

export const fetchBannersThunk = createAsyncThunk(
    "banners/fetchAll", 
    async (marketType, { rejectWithValue }) => {
    try {
        const data = await fetchBanners(marketType);
        return Array.isArray(data) ? data : data.banners || [];
    } catch (error) {
        return rejectWithValue(error.message || "Failed to fetch banners");
    }
});

export const createBannerThunk = createAsyncThunk(
    "banners/create",
    async (payload, { rejectWithValue }) => {
        try {
            return await createBanner(payload);
        } catch (error) {
            return rejectWithValue(error.message || "Failed to create banner");
        }
    }
);


export const updateBannerThunk = createAsyncThunk(
    "banners/update",
    async (payload, { rejectWithValue }) => {
        try {
            return await updateBanner(payload);
        } catch (error) {
            return rejectWithValue(error.message || "Failed to update banner");
        }
    }
);


export const deleteBannerThunk = createAsyncThunk(
    "banners/delete",
    async (bannerId, { rejectWithValue }) => {
        try {
            return await deleteBanner(bannerId);
        } catch (error) {
            return rejectWithValue(error.message || "Failed to create banner");
        }
    }
);
